module.exports = __webpack_public_path__ + "static/media/gabon.dc24cdc0.svg";